import React, { useContext, useEffect, useMemo } from 'react';
import { useOnboarding } from '../hooks/useOnboarding';


export const OnboardingContext = React.createContext()

export const OnboardingProvider = ({ children }) => {
    const state = useOnboarding()
    const value = useMemo(() => state, [state])


    useEffect(() => { console.log("OnboardingProvider => ", value) }, [value])

    return (
        <OnboardingContext.Provider value={value}>
            {children}
        </OnboardingContext.Provider>
    );
}

export function useOnboardingContext() {
    return useContext(OnboardingContext)
}
